module.exports = require('./lib/_stream_writable.js');



// WEBPACK FOOTER //
// (webpack)/~/readable-stream/writable-browser.js